import { useMutation } from '@apollo/client';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useState } from 'react';
import { REMOVE_DOMAIN } from '../../../../helpers/graphql/hosting';
import { useSnackbar } from 'notistack';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';

import { red } from '@mui/material/colors';

const theme = createTheme({
  palette: {
    primary: red,
  },
});

export default function RemoveDomain({
  blogId,
  setBuildProgress,
  setStatus,
  startPolling,
  blog,
}) {
  const [loading, setLoading] = useState(false);

  const [open, setOpen] = useState('');

  const { enqueueSnackbar } = useSnackbar();

  const [removeDomain] = useMutation(REMOVE_DOMAIN);

  const handleRemoveDomain = () => {
    setLoading(true);
    removeDomain({
      variables: {
        blogId,
      },
    })
      .then(({ data }) => {
        if (data?.removeDomain?.success) {
          setOpen(false);
          setBuildProgress(5);
          setStatus('loading');
          startPolling(5000);
          window.location.href = `/dashboard/hosting/general?blogId=${blogId}`;
        } else
          enqueueSnackbar('Your domain could not be removed', {
            variant: 'error',
          });
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar('Something went wrong', { variant: 'error' });
        setLoading(false);
      });
  };

  return (
    <>
      <Dialog
        onClose={() => setOpen(false)}
        open={open}
        aria-labelledby="alert-domainwizard-title"
        aria-describedby="alert-domainwizard-description"
      >
        <DialogTitle id="alert-domainwizard-title">Remove domain</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure that you want to remove your domain? If you remove your
            domain, your blog will only be available on {blogId}.truvvl.blog and
            no longer on {blog.domain}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(undefined)} color="primary">
            Cancel
          </Button>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <Button
                variant="contained"
                onClick={handleRemoveDomain}
                disabled={loading}
              >
                Remove domain
              </Button>
            </ThemeProvider>
          </StyledEngineProvider>
        </DialogActions>
      </Dialog>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <Button variant="contained" onClick={() => setOpen(true)}>
            Remove domain
          </Button>
        </ThemeProvider>
      </StyledEngineProvider>
    </>
  );
}
